<template>
    <div class="w-100">
        <form class="w-100 client__notes__form mt--5" @submit.prevent="">
            <div>
                <input 
                    id="taskName"
                    ref="newTask" 
                    v-model="form.name" 
                    class="form-control form-control-sm task__item__inline__input" 
                    type="text" placeholder="What do you want to do?"
                >
                <input 
                    id="taskDescription" 
                    v-model="form.description" 
                    class="form-control form-control-sm sub task__item__inline__input" 
                    type="text" placeholder="Add task description here..."
                >
            </div>

            <div class="task__action__btns pr--0">
                <BaseButton
                    class="mr--5" label="Cancel" variant="outline"
                    @submit="showNewTask = false"
                />
                <BaseButton 
                    type="submit" 
                    label="Add" 
                    :loading="loading"
                    :disabled="!form.name || loading" 
                    @submit="onSubmit"
                />
            </div>
        </form>
    </div>
</template>

<script>
import {
    BaseButton,
} from "@/components/ui/index";

export default {
    name: "TaskForm",

    components: {
        BaseButton,
    },

    props: {
        projectId: {
            type: String,
            default: "",
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },

    emits: ["form-complete"],

    data() {
        return {
            form: {
                name: "",
                description: "",
                projectId: null,
                priority: null,
                deadline: null,
                isCompleted: false,
            },
            showNewTask: false,
        };
    },

    watch: {
        showNewTask(newVal) {
            if (newVal) {
                this.$nextTick(() => {
                    this.$refs?.newTask?.focus();
                });
            }
        },
    },

    methods: {
        onSubmit() {
            const payload = { 
                name: this.form.name, 
                description: this.form.description || null,
                projectId: this.projectId || null,
                priority: "low",
                deadline: null,
                isCompleted: false,
                reminders: [],
            };

            this.$emit("form-complete", {
                payload,
                resetFn: () => {
                    this.form = {
                        name: "",
                        description: "",
                        projectId: "",
                        priority: null,
                        deadline: null,
                        isCompleted: false,
                    };
                },
            });
        },
    },
};
</script>